/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import CustomLayout from "./wrapPageElement"
import React from "react"
import { DealerProvider } from "./src/state/dealerProvider"

export const wrapPageElement = CustomLayout

export const wrapRootElement = ({ element }) => {
  return <DealerProvider>{element}</DealerProvider>
}
